import { ZERO_WIDTH_SPACE } from "@utils/ZERO_WIDTH_SPACE";
import { replacePatternXWhenWrappedInPatternY } from "./replacePatternXWhenWrappedInPatternY";

const JAPANESE_UNICODE_RANGES = [
  /* Hiragana */ "\\u3040-\\u309F",
  /* Katakana */ "\\u30A0-\\u30FF",
  /* Katakana Phonetic Extensions */ "\\u31F0-\\u31FF",
  /* CJK Symbols and Punctuation */ "\\u3000-\\u303F",
  /* Common Kanji */ "\\u4E00-\\u9FFF",
  /* Shared CJK Ideographs */ "\\u4E00-\\u9FFF",
];

export const replaceWhitespaceBetweenJapaneseCharactersWithZwsp =
  replacePatternXWhenWrappedInPatternY(
    " ",
    `[${JAPANESE_UNICODE_RANGES.join("")}]`,
    ZERO_WIDTH_SPACE
  );
